export const images = [
    { url: require('./img/scratchboard.png') },
    { url: require('./img/oil_paint8.jpg') },
    { url: require('./img/oil_paint3.jpg') },
    { url: require('./img/oil_paint7.jpg') },
    { url: require('./img/oil_paint9.jpg') },
    { url: require('./img/grad_cap.png') },
]